import { AsyncState } from 'widgets-for-react'
import { ComponentTeaserData } from '../../components/componentTeasers/componentTeasersState'
import { ImageData } from '../../image/imageState'
import { loadGuestChefHighlight } from './guestChefHighLight.api'

export type GuestChefHighlightState = AsyncState<GuestChefHighlight>

export type GuestChefHighlight = {
  firstName: string
  lastName: string
  introduction: string
  image: ImageData
  components: ComponentTeaserData[]
}

export const initialGuestChefHightlightState = (
  id: number
): GuestChefHighlightState => loadGuestChefHighlight(id)
